const STORAGE_KEY = 'mvp_public_events';
const MAX_EVENTS = 200;
const SESSION_KEY = 'mvp_public_session_id';

function getSessionId() {
  try {
    const existing = localStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const next =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `sess_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SESSION_KEY, next);
    return next;
  } catch {
    return `sess_${Date.now()}`;
  }
}

async function sendToBackend(eventName, payload, path, sessionId) {
  try {
    await fetch('/api/mvp/analytics/events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        eventName,
        payload,
        path,
        sessionId,
      }),
      keepalive: true,
    });
  } catch {
    // Ignore network errors for non-blocking analytics.
  }
}

export function trackMvpEvent(eventName, payload = {}) {
  const sessionId = getSessionId();
  const path = window.location.pathname;
  const event = {
    eventName,
    payload,
    timestamp: new Date().toISOString(),
    path,
    sessionId,
  };

  try {
    const existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    const next = [event, ...existing].slice(0, MAX_EVENTS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // Ignore storage errors for non-blocking analytics.
  }

  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', eventName, payload);
  }

  sendToBackend(eventName, payload, path, sessionId);
}
